import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, X, Search, Download, Edit } from 'lucide-react';
import TimeSelector from './TimeSelector';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';
export default function DocentePrestamos() {
  const [prestamos, setPrestamos] = useState([]);
  const [articulos, setArticulos] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [editingPrestamo, setEditingPrestamo] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id_articulo: '',
    cantidad: 1,
    id_sala: '',
    fecha_solicitud: '',
    hora_solicitud: '',
    fecha_devolucion: '',
    hora_devolucion: '',
    comentarios: ''
  });

  const getHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  });

  useEffect(() => {
    loadPrestamos();
    loadArticulos();
  }, []);

  const loadPrestamos = async () => {
    try {
      const response = await fetch(`${API_URL}/docente/prestamos`, { headers: getHeaders() });
      const data = await response.json();
      setPrestamos(data.prestamos || []);
    } catch (error) {
      console.error('Error loading prestamos:', error);
      setPrestamos([]);
    }
  };

  const loadArticulos = async () => {
    try {
      const response = await fetch(`${API_URL}/docente/articulos`, { headers: getHeaders() });
      const data = await response.json();
      setArticulos(data.articulos || []);
    } catch (error) {
      console.error('Error loading articulos:', error);
      setArticulos([]);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingPrestamo
        ? `${API_URL}/docente/prestamos/${editingPrestamo.id_prestamo}`
        : `${API_URL}/docente/prestamos`;

      const method = editingPrestamo ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify({
          ...formData,
          fecha_solicitud: new Date().toISOString().split('T')[0],
          hora_solicitud: new Date().toLocaleTimeString('es-BO', { hour: '2-digit', minute: '2-digit', hour12: false })
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message);
        setShowModal(false);
        resetForm();
        await loadPrestamos();
      } else {
        alert(data.message || 'Error al guardar préstamo');
      }
    } catch (error) {
      console.error('Error saving prestamo:', error);
      alert('Error al guardar préstamo');
    }
  };

  const handleEdit = (prestamo) => {
    setEditingPrestamo(prestamo);
    setFormData({
      id_articulo: prestamo.id_articulo || '',
      cantidad: prestamo.cantidad || 1,
      id_sala: prestamo.id_sala || '',
      // fecha_solicitud: prestamo.fecha_solicitud || '',
      // hora_solicitud: prestamo.hora_solicitud || '',
      // fecha_devolucion: prestamo.fecha_devolucion || '',
      // hora_devolucion: prestamo.hora_devolucion || '',
      fecha_solicitud: prestamo.fecha_solicitud ? prestamo.fecha_solicitud.split('T')[0] : '',
      hora_solicitud: prestamo.hora_solicitud ? prestamo.hora_solicitud.substring(0, 5) : '',
      fecha_devolucion: prestamo.fecha_devolucion ? prestamo.fecha_devolucion.split('T')[0] : '',
      hora_devolucion: prestamo.hora_devolucion ? prestamo.hora_devolucion.substring(0, 5) : '',
      comentarios: prestamo.comentarios || ''
    });
    setShowModal(true);
  };

  const resetForm = () => {
    setEditingPrestamo(null);
    setFormData({
      id_articulo: '',
      cantidad: 1,
      id_sala: '',
      fecha_solicitud: '',
      hora_solicitud: '',
      fecha_devolucion: '',
      hora_devolucion: '',
      comentarios: ''
    });
  };

  const getEstadoBadge = (estado) => {
    const colors = {
      pendiente: 'bg-yellow-100 text-yellow-800',
      aprobado: 'bg-green-100 text-green-800',
      observado: 'bg-red-100 text-red-800'
    };
    return colors[estado] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div >
          <div className="flex items-center justify-between">
            <div className="mb-6">
              <h1 className="text-xl font-bold">Docente &gt; Préstamos</h1>
            </div>
            <button
              onClick={() => {
                resetForm();
                setShowModal(true);
              }}
              className="flex items-center gap-2 px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800"
            >
              <Plus size={18} />
              Añadir Préstamo
            </button>
          </div>
        </div>

        {/* Tabla de Préstamos */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          {false ? (
            <div className="p-8 text-center text-gray-500">Cargando...</div>
          ) : prestamos.length === 0 ? (
            <div className="p-8 text-center text-gray-500">No hay préstamos registrados</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-3 py-3 text-center font-semibold border">No</th>
                    <th className="px-3 py-3 text-center font-semibold border">Artículo</th>
                    <th className="px-3 py-3 text-center font-semibold border">Cantidad</th>
                    <th className="px-3 py-3 text-center font-semibold border">Sala</th>
                    <th className="px-3 py-3 text-center font-semibold border">Comentarios</th>
                    <th className="px-3 py-3 text-center font-semibold border">Fecha Solicitud</th>
                    <th className="px-3 py-3 text-center font-semibold border">Hora Solicitud</th>
                    <th className="px-3 py-3 text-center font-semibold border">Fecha Devolución</th>
                    <th className="px-3 py-3 text-center font-semibold border">Hora Devolución</th>
                    <th className="px-3 py-3 text-center font-semibold border">Estado</th>
                    <th className="px-3 py-3 text-center font-semibold border">Observaciones JC</th>
                    <th className="px-3 py-3 text-center font-semibold border">Devolución</th>
                    <th className="px-3 py-3 text-center font-semibold border">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {prestamos.map((prest, idx) => (
                    <tr key={prest.id_prestamo} className="border-b hover:bg-gray-50">
                      <td className="p-3 border">{idx + 1}</td>
                      <td className="p-3 text-sm font-medium border">{prest.articulo_nombre || '-'}</td>
                      <td className="p-3 text-sm border">{prest.cantidad}</td>
                      <td className="p-3 text-sm border">{prest.id_sala ? `Sala ${prest.id_sala}` : (prest.sala_nombre || '-')}</td>
                      <td className="p-3 text-sm text-gray-600 max-w-xs truncate border">{prest.comentarios || '-'}</td>
                      <td className="p-3 text-sm border">
                        {prest.fecha_solicitud ? new Date(prest.fecha_solicitud).toLocaleDateString() : '-'}
                      </td>
                      <td className="p-3 text-sm border">{prest.hora_solicitud || '-'}</td>
                      <td className="p-3 text-sm border">
                        {prest.fecha_devolucion ? new Date(prest.fecha_devolucion).toLocaleDateString() : '-'}
                      </td>
                      <td className="p-3 text-sm border">{prest.hora_devolucion || '-'}</td>
                      <td className="p-3 text-sm border">
                        <span className={`px-2 py-1 rounded-full text-xs ${getEstadoBadge(prest.estado)}`}>
                          {prest.estado}
                        </span>
                      </td>
                      <td className="p-3 text-sm text-gray-600 max-w-xs truncate border">
                        {prest.observaciones_jefatura || '-'}
                      </td>
                      <td className="p-3 text-sm border">
                        {prest.devuelto ? (
                          <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Sí</span>
                        ) : (
                          <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">No</span>
                        )}
                      </td>
                      <td className="p-3 border">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => handleEdit(prest)}
                            className={`p-1 rounded ${prest.estado !== 'pendiente'
                                ? 'text-gray-300 cursor-not-allowed'
                                : 'text-blue-600 hover:bg-blue-50'
                              }`}
                            disabled={prest.estado !== 'pendiente'}
                            title={prest.estado !== 'pendiente' ? 'Solo se pueden editar préstamos pendientes' : 'Editar'}
                          >
                            <Edit size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center  py-2 border-b sticky top-0 bg-white z-10 mb-6">
                  <h2 className="text-xl font-bold text-blue-900">
                    {editingPrestamo ? 'Editar Préstamo' : 'Nueva Solicitud de Préstamo'}
                  </h2>
                  <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-700">
                    <X size={24} />
                  </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Artículo *</label>
                      <select
                        name="id_articulo"
                        value={formData.id_articulo}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Seleccionar</option>
                        {articulos.map(a => (
                          <option key={a.id_articulo} value={a.id_articulo}>
                            {a.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Cantidad *</label>
                      <input
                        type="number"
                        name="cantidad"
                        value={formData.cantidad}
                        onChange={handleChange}
                        min="1"
                        max="999"
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div className="sm:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Sala *</label>
                      <select
                        name="id_sala"
                        value={formData.id_sala}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Seleccionar</option>
                        {Array.from({ length: 20 }, (_, i) => i + 1).map(n => (
                          <option key={n} value={n}>Sala {n}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha Devolución *</label>
                      <input
                        type="date"
                        name="fecha_devolucion"
                        value={formData.fecha_devolucion}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Hora Devolución *</label>
                      <TimeSelector
                        name="hora_devolucion"
                        value={formData.hora_devolucion}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="sm:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Comentarios</label>
                      <textarea
                        name="comentarios"
                        value={formData.comentarios}
                        onChange={handleChange}
                        rows={3}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 pt-4 border-t">
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800"
                    >
                      Guardar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}